import { requestApi } from '../util/network'

export const getInfo =
() =>
  requestApi(
    '/o2o_fuwu_manage_info/get_info',
    'POST',
    {
    },
    'fuwu'
  )

export const editInfoBase =
(data) =>
  requestApi(
    '/o2o_fuwu_manage_info/edit_info_base',
    'POST',
    {
      organization_name: data.organization_name,
      organization_phone: data.organization_phone,
      organization_birthday: data.organization_birthday,
      organization_region_id: data.organization_region_id,
      organization_region_name: data.organization_region_name,
      organization_city_id: data.organization_city_id,
      organization_city_name: data.organization_city_name,
      organization_address: data.organization_address,
      organization_lng: data.organization_lng,
      organization_lat: data.organization_lat
    },
    'fuwu'
  )
export const editInfoOperate =
    (data) =>
      requestApi(
        '/o2o_fuwu_manage_info/edit_info_operate',
        'POST',
        {
          organization_payment_account: data.organization_payment_account,
          organization_open_start: data.organization_open_start,
          organization_open_end: data.organization_open_end,
          class_id_1: data.class_id_1,
          class_name_1: data.class_name_1,
          class_id_2: data.class_id_2,
          class_name_2: data.class_name_2,
          class_id_3: data.class_id_3,
          class_name_3: data.class_name_3,
          organization_detail: data.organization_detail
        },
        'fuwu'
      )
export const uploadInfoFile =
(file) =>
  requestApi(
    '/o2o_fuwu_manage_info/upload_info_file',
    'POST',
    file,
    'fuwu',
    true
  )
export const getInfoFileList =
    (type) =>
      requestApi(
        '/o2o_fuwu_manage_info/get_info_file_list',
        'POST',
        {
          type: type
        },
        'fuwu'
      )
export const delInfoFile =
    (id) =>
      requestApi(
        '/o2o_fuwu_manage_info/del_info_file',
        'POST',
        {
          id: id
        },
        'fuwu'
      )
